import { reorderDate } from "get-life-storybook-ts";
import React from "react";
import { GetLifeCalculatorContext } from "../../../context/GetLifeCalculator.context";

const CalculatorPageITController = () => {
  const contextCalculator = React.useContext(GetLifeCalculatorContext);

  const handleClickOrganic = () => {
    const capital = parseFloat(contextCalculator.insuranceCover);
    contextCalculator.handleClickOrganic({
      birthDate: reorderDate(contextCalculator.dateOfBirth),
      campaign: contextCalculator.gtf_campaign || "calculator-app",
      capital,
      capitalsByTrait: { DEATH: capital },
      email: contextCalculator.email,
      gender: contextCalculator.sex,
      initialCapital: contextCalculator.minCapital,
      phone: contextCalculator.phoneNumber,
      nicotine: contextCalculator.smoke,
      // 2ª casilla = marketing directo (facoltativo). La 3ª es la confirmación de titularidad,
      // obligatoria, y hacía que el consentimiento de marketing fuese siempre true.
      userAcceptsCommunications: contextCalculator.checkedConditions2
    });
  };

  const options = {
    smoke: [
      {
        value: "yes",
        text: contextCalculator.translate("yes"),
        label: contextCalculator.translate("yes"),
        illustration: "SmokerIcon",
        variant: "Illustration"
      },
      {
        value: "no",
        text: contextCalculator.translate("no"),
        label: contextCalculator.translate("no"),
        illustration: "NonSmokerIcon",
        variant: "Illustration"
      },
    ],
  };

  return { contextCalculator, handleClickOrganic, options };
};

export default CalculatorPageITController;
